<script>
  import { useNavigate } from "svelte-navigator";
  import { onMount } from "svelte";
  import Form from "../components/form/Form.svelte";
  import SingleCheckbox from "../components/form/SingleCheckbox.svelte";
  import Validators from "../utils/validators";
  import { headerDisplayStore, loadingStore } from "../stores/General";
  import { create, update, getById, getList } from "../api";
  import FormButtons from "../components/form/FormButtons.svelte";
  import PublisherBlockList from "../components/form/PublisherBlockList.svelte";
  import InputWrapper from "../components/form/InputWrapper.svelte";
  import EligibleGeoAndInventory from "../components/EligibleGeoAndInventory.svelte";
  import { v4 } from "uuid";
  import GenericButton from "../components/button/GenericButton.svelte";
  import ActivateModal from "../components/modal/ActivateModal.svelte";
  import changesStore from "../stores/Changes";
  import { remove } from "../api";
  import PlainInput from "../components/form/PlainInput.svelte";
  import AutoCompleteCombo from "../components/form/AutoCompleteCombo.svelte";
  import { Exclamation } from 'svelte-hero-icons';
  import SelectInput from "../components/form/SelectInput.svelte";

  const navigate = useNavigate();

  const module_name = "demand";

  export let id = "";
  let demandPartner = null;
  let demand_partner_types = [];
  let demand_partner_type = "0";
  let qps = 0;
  let max_bid_floor = 0;
  let publisherChannelsValue = [];
  let rating = [];
  let genres = [];
  let includePublishersInInventory = true;
  let countriesValue = [{ label: "United States", value: "US" }];
  let global_block = false;
  let showModal = false;
  let default_product_category;
  let upsell_exception = [];
  let modalData = {};
  $: name = "";

  //  dmasValue = [];
  // let address_type = "State";
  // let statesValue = [];
  // let zipCodes = "";
  // $: regionsValue = []

  async function getDemandPartnerTypes() {
    try {
      const res = await getList("demand/types", 10, 1, "name", "asc", {});
      return res.data.map((p) => ({ value: p.id, label: p.name }));
    } catch (error) {
      headerDisplayStore.ShowError({
        title: "Failed to fetch demand partner types",
      });
    }
  }
  //function to parse categories into tire1 | tire two labels
  async function loadDemandPartner() {
    getById(module_name, id)
      .then((response) => {
        const d = response.demand_partner;
        if (d) {
          demandPartner = d;
          name = demandPartner.name;
          demand_partner_type =
            demand_partner_types[d.demand_partner_type || 0];
          publisherChannelsValue = d.inventory?.publishers || [];
          genres = d.inventory?.genres || [];
          rating = d.inventory?.rating || [];
          includePublishersInInventory = d.inventory?.shouldInclude; 
          block_list = d.block_list ?? [];
          default_product_category = d.default_product_category;
          upsell_exception = d.upsell_exception;

          global_block = d.global_block || false;
          // statesValue = d.geo?.states;
          // dmasValue = d.geo?.dmasValue || [];
          countriesValue = d.geo?.countries || countriesValue;
          qps = d.qps;
          max_bid_floor = d.max_bid_floor;
        }
      })
      .catch((error) => {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
        navigate("/demand_partners");
      });
  }

  onMount(async () => {
    loadingStore.on(module_name);
    headerDisplayStore.SetTitle("New Demand Partner");
    demand_partner_types = await getDemandPartnerTypes();
    if (id) {
      headerDisplayStore.SetTitle("Edit Demand Partner");
      await loadDemandPartner();
    } else {
      demandPartner = { disabled: false, demand_partner_id: v4() };
    }
    headerDisplayStore.SetBreadCrumbs([
      {
        key: "demand_partners",
        label: "Demand Partners",
      },
      {
        key: "new",
        label: "New",
      },
    ]);
    loadingStore.off();
  });
  let block_list = [];
  let form;
  let rules = {
    name: {
      validators: [
        Validators.required("Demand Partner name is required"),
        Validators.minLength(3),
        Validators.exists(
          validateTextField,
          "Demand Partner Name already exists"
        ),
      ],
    },
  };

  $: demand_partner_type_id = demand_partner_type?.value || demand_partner_type;

  function onSubmit(e) {
    loadingStore.on(module_name, { disableGlobalIndicator: true });
    let { data } = e.detail;
   // return
    // if (!name?.length) {
    //   loadingStore.off();
    //   headerDisplayStore.ShowError({
    //     title: "Error",
    //     subtitle: "Demand Partner name is missing",
    //   });
    //   return;
    // }

    // if (data.name.length < 3) {
    //   headerDisplayStore.ShowError({
    //     title: "Error",
    //     subtitle: "Name should be at least 3 characters",
    //   });
    //   return;
    // }

    const _data = {
      demand_partner_id: demandPartner?.demand_partner_id || id,
      demand_partner_type: demand_partner_type_id,
      name: data.name,
    };

    switch (demand_partner_type_id) {
      case "0":
        _data.block_list = block_list;
        _data.global_block = data.global_block ? true : false;
        _data.inventory = {};
        _data.geo = {};
        _data.qps = 0;
        _data.max_bid_floor = 0;
        break;
      case "1":
        _data.inventory = {};
        _data.geo = {};
        _data.global_block = false;
        _data.qps = 0;
        _data.max_bid_floor = 0;
        if (block_list.length)
          changesStore.delete("block_list", block_list, "adomains");
        _data.block_list = [];
        break;

      default:
        _data.qps = parseFloat(qps) || 0;
        _data.max_bid_floor = parseFloat(max_bid_floor) || 0;
        _data.inventory = {
          shouldInclude: includePublishersInInventory,
          publishers: publisherChannelsValue, // TODO: each object contains a publisher_name: {...} instead of publisher_id
          rating,
          genres,
        };
        _data.global_block = false;
        _data.geo = {
          countries: countriesValue,
          // zip: TODO no data to bind
          // max_utilization: TODO no data to bind
        };
        _data.default_product_category =
          default_product_category?.value || null;
        _data.upsell_exception = upsell_exception;
        if (block_list.length)
          changesStore.delete("block_list", block_list, "adomains");
        _data.block_list = [];
        break;
    }

    if ($changesStore.block_list?.delete.length > 0) {
      remove(module_name + "/adomains", {
        adomains: $changesStore.block_list.delete,
        demand_partner_id: _data.demand_partner_id,
      }).catch(() => {
        headerDisplayStore.ShowError({
          title: "Error",
          subtitle: "Delete adomains failed",
        });
      });
    }

    const send = id ? update : create;
    send(module_name, _data)
      .then((response) => {
        loadingStore.off();
        if (response?.status === "ok") {
          headerDisplayStore.ShowNotification({
            title: "Success",
            subtitle: "Demand Partner saved successfully",
          });
          onCancel();
        } else {
          headerDisplayStore.ShowError({
            title: "Error",
            subtitle: response?.error,
          });
        }
      })
      .catch((error) => {
        loadingStore.off();
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }

  function handleDPTypeChange(e) {
    demand_partner_type = e.detail;
  }

  function onCancel() {
    navigate("/demand_partners");
  }

  async function validateTextField(name) {
    // name = e.detail.target.value;
    let page = 1;
    let sortBy = "name";
    let sortOrder = "ASC";
    let filter = { name };

    const { data } = await getList(
      module_name,
      10,
      page,
      sortBy,
      sortOrder,
      filter
    ).catch((error) => {
      headerDisplayStore.ShowError({
        title: "Server error",
      });
    });
    // console.log(data, id);
    const count = data?.length || 0;
    if (count && data[0]?.demand_partner_id == id) {
      return [];
    }

    return data;
  }
  //Function that takes a component to be rendered in the base modal and the action.
  function ToggleModal(action) {
    //modalData is an object sending all necessary data to the modal
      modalData.headerText = "Warning";
      modalData.Icon = Exclamation;
    if (action == "activate") {
      modalData.body = "Are you sure you want to activate the partner?";
      modalData.rightButtonText = "Activate";
      modalData.rightButtonType = "success-solid";
    } else {
      modalData.body = "Are you sure you want to deactivate the partner?";
      modalData.rightButtonText = "Deactivate";
      modalData.rightButtonType = "danger-solid";
    }
    showModal = !showModal;
  }

  function ToggleActivate() {
    let data = {
      demand_partner_id: demandPartner.demand_partner_id,
      disabled: !demandPartner.disabled,
    };

    update(module_name, data)
      .then((response) => {
        if (response?.status === "ok") {
          headerDisplayStore.ShowNotification({
            title: "Success",
            subtitle: "Partner saved successfully",
          });
          onCancel();
        } else {
          headerDisplayStore.ShowError({
            title: "Error",
            subtitle: response?.error,
          });
        }
      })
      .catch((error) => {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }
</script>

<div class="max-w-full mx-auto py-6 px-4 sm:px-6 md:px-8 mb-10">
  {#if !id || (id && demandPartner)}
    <Form {rules} on:submit={onSubmit} bind:this={form}>
      <div class="bg-white p-8 w-full rounded-md">
        <div class="flex flex-row gap-3">
          <InputWrapper label="Demand Partner Name" name="name" required>
            <PlainInput
              bind:value={name}
              name="name"
              placeholder="Enter Demand Partner Name"
            />
          </InputWrapper>

          <InputWrapper label="Demand Partner ID">
            <PlainInput
              value={demandPartner?.demand_partner_id || id}
              name="demand_partner_id"
              readonly
            />
          </InputWrapper>

          <InputWrapper label="Type">
            <SelectInput
              type="combo"
              name="demand_partner_type"
              isSearchable={false}
              isClearable={false}
              items={demand_partner_types}
              loadOptions={getDemandPartnerTypes}
              on:change={handleDPTypeChange}
              value={demand_partner_type}
            />
          </InputWrapper>
          {#if demand_partner_type_id == "0"}
            <SingleCheckbox
              name="global_block"
              label="Global Block"
              bind:value={global_block}
            />
          {/if}
        </div>
        {#if demand_partner_type_id != "0" && demand_partner_type_id != "1"}
          <div class="flex flex-row gap-2">
            <InputWrapper label="QPS Limit">
              <PlainInput
                name="qps"
                min={0}
                step={0.1}
                bind:value={qps}
                type="number"
              />
            </InputWrapper>

            <InputWrapper label="Max Bid Floor">
              <PlainInput
                name="max_bid_floor"
                min={0}
                step={0.01}
                bind:value={max_bid_floor}
                prefix="$"
                type="number"
              />
            </InputWrapper>
          </div>
          <div class="flex flex-row gap-2">
            <div class="w-1/2">
              <InputWrapper label="Default Product Category for oRTB execution">
                <AutoCompleteCombo
                  placeholder="Select Default Category"
                  name="default_product_category"
                  isClearable={false}
                  value={default_product_category}
                  on:change={(e) => {
                    default_product_category = e.detail;
                  }}
                  items={["Open", "Instant"]}
                />
              </InputWrapper>
            </div>
            {#if default_product_category?.value == "Open" || default_product_category == "Open"}
              <div class="w-1/2">
                <InputWrapper label="Upsell Exception Ad Domains">
                  <AutoCompleteCombo
                    placeholder="Select Upsell Exception"
                    name="upsell_exception"
                    isClearable={true}
                    isMulti={true}
                    isSelectAll={true}
                    isUnknown={true}
                    bind:value={upsell_exception}
                    entity="adomain_daily"
                  />
                </InputWrapper>
              </div>
            {/if}
          </div>
          <EligibleGeoAndInventory
            bind:publisherChannelsValue
            bind:rating
            bind:genres
            bind:countriesValue
            bind:includePublishersInInventory
          />
        {:else if demand_partner_type_id == "0"}
          <div class="flex flex-row gap- mt-5">
            <PublisherBlockList bind:block_list name="block_list" />
          </div>
        {/if}
        <div class="flex flex-row justify-between mt-10">
          {#if id}
            {#if demandPartner.disabled}
              <GenericButton
                text="Activate"
                buttonTheme="success-light"
                onClick={() => {
                  ToggleModal("activate");
                }}
              />
            {:else}
              <GenericButton
                text="Deactivate"
                buttonTheme="danger-light"
                onClick={() => {
                  ToggleModal("deactivate");
                }}
              />
            {/if}
          {/if}
        </div>
      </div>
      <FormButtons isUpdate={!!id} on:cancel={onCancel} />
      {#if showModal}
        <ActivateModal
          on:click={ToggleModal}
          {modalData}
          on:modalSubmit={ToggleActivate}
        />
      {/if}
    </Form>
    <!-- {:else}
    <div class="min-w-full loader-container text-center">
      <div class="align-middle inline-block h-16">
        <Moon size="4" color="#FF3E00" unit="rem" duration="1s" />
      </div>
      <div class="align-middle inline-block h-full" />
    </div> -->
  {/if}
</div>
